let timeOut;
function feedback_system(status, message, timeout=true) {
    let $feed = $("[data-name='ajax-feedback']"),
        $wrapper = $feed.children('#wrapper'),
        $closefeedback = $feed.find('#close-feedback'),
        $feed_main_text = $feed.find('.feed-main-text');
	$feed.removeClass();
	$wrapper.removeClass();
	$wrapper.addClass(status);

	if (timeout){
        clearTimeout(timeOut);
        timeOut = setTimeout(function () {
            $feed.removeClass().addClass('fake-hidden');
        }, 3000);
    } else {
        $closefeedback.removeClass('hidden');
    }

    
    $feed_main_text.html(message);
}

let header = () => {
    let st = $(this).scrollTop();
    if (st > 20) {
        $('header').addClass('is_moving');
    } else {
        $('header').removeClass('is_moving');
    }
}

let progressnav = () => {
    let docHeight = $("body").height();
        let winHeight = $(window).height();
        let viewport = docHeight - winHeight;
        let scrollPos = $(window).scrollTop();
        let scrollPercent = (scrollPos / viewport) * 100;
        $(".indicator").css("width", scrollPercent + "%");
}

let counters = function() {
    let counter = $("[data-name='counter']"),
        counts = ["400", "900", "60"],
        start_scroll = 900,
        end_scroll = 1100;
    
    if ($(document).scrollTop() >= end_scroll) {
        counter.addClass('done');
    }
    
    if ($(document).scrollTop() >= start_scroll && $(document).scrollTop() < end_scroll) {
        if (!counter.hasClass('done')) {
            counter.each(function (i, el) {
                anime({
                    targets: "[data-index='"+i+"']>bdi",
                    innerHTML: [0, counts[i]],
                    easing: 'easeInOutCubic',
                    duration: 2700,
                    round: 1
                });
                
                if (i === 3) {
                    counter.addClass('done');
                } 
            });
        }
    } else if ($(document).scrollTop() >= end_scroll) {
        counter.each(function (i, el) {
            $("[data-index='"+i+"'] bdi").text(counts[i]);
        })
    }
}


//my Own Manual Powerfull Slider WoW!
function leftSlide() {
    $(".slider-wrapper .active").each(function () {
        if ($(".slider-wrapper").children().first().hasClass("active")) {
            $(".slider-wrapper").children().first().removeClass("active").addClass("hidden");
            $(".slider-wrapper").children().last().removeClass("hidden").addClass("active");
        }
        
    $(this).addClass("hidden").removeClass("active");
    $(this).prev().addClass("active").removeClass("hidden");

    });
}

//************************************************************
function rightSlide() {
    $(".slider-wrapper .active").each(function () {
        if ($(".slider-wrapper").children().last().hasClass("active")) {
            $(".slider-wrapper").children().last().removeClass("active").addClass("hidden");
            $(".slider-wrapper").children().first().removeClass("hidden").addClass("active");
        }

    $(this).addClass("hidden").removeClass("active");
    $(this).next().addClass("active").removeClass("hidden");
    });
}



//handle uploaded files
function handleFiles() {
    let filesLength = this.files.length,
        label = $(this).parent('.file-member').find(".blog-label"),
        $uploaded_image = label.parent('.wrapper').children('.uploaded-image'),
        $image_wrapper = label.parent('.wrapper').find('#image-wrapper');
    label.addClass('hidden');
    $uploaded_image.removeClass('hidden');


    if (filesLength){
        $image_wrapper.html("");
        for (let i = 0; i < filesLength; i++) {
          const img = document.createElement("img");
            img.src = URL.createObjectURL(this.files[i]);
            img.onload = function() {
                URL.revokeObjectURL(this.src);
                //console.log($('#blog-photo').val());
            }
            $image_wrapper.html(img);
        }
        $('.cancel-upload-image').on('click', function () {
            $image_wrapper.html("");
            $('#blog-photo').val("");
            $uploaded_image.addClass('hidden');
            label.removeClass('hidden');
        });
    } else {
        $image_wrapper.html("");
        $uploaded_image.addClass('hidden');
        label.removeClass('hidden');
    }
}